<div *ngIf="!isRealAttendanceEntered" [showIfPrivileges]="'GroupClasses.canManageClasses'">
    <a class="cursor-pointer" (click)="registerAttendees()">
        <div class="circle">+</div>
        <span class="attendance-register-text" translate> GroupClassDetails.RegisterAttendeesButton</span>
    </a>
</div>
<div *ngIf="isRealAttendanceEntered">
    <div class="row mt-3">
        <div class="col-10 text-dimmed">

            <a [showIfPrivileges]="'GroupClasses.canManageClasses'" class="cursor-pointer mr-3"
                (click)="editAttendees()">
                <span class="ic_pencil mr-1"></span>
                <span class="attendance-register-text align-bottom" translate>GroupClassDetails.AttendeesEditButton</span>
            </a>
            <strong class="align-bottom">{{ model.realAttendance }}</strong>
            <span class="align-bottom" *ngIf="isRealAttendanceValueIsPlural" translate>
                GroupClassDetails.AttendeesRegisteredPlural</span>
            <span class="align-bottom" *ngIf="!isRealAttendanceValueIsPlural" translate>
                GroupClassDetails.AttendeesRegisteredSingular</span>
        </div>
    </div>
</div>
